
























































































































import {Component, Vue} from "vue-property-decorator";
import {Customer} from "@/entity/Customer";
import {getModule} from "vuex-module-decorators";
import {CustomerStore} from "@/store/CustomerStore";
import {AuthStore} from "@/oauth/AuthStore";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {CustomerDto} from "@/dto/CustomerDto";
import KeShangMain from "@/views/KeShangMain.vue";
import {CollectCompany} from "@/entity/CollectCompany";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";
import {types} from "sass";
import { MerchantCircle } from "@/entity/MerchantCircle";
import { MerchantCircleDto } from "@/dto/MerchantCircleDto";
import TieZiView from "@/components/TieZiView.vue";
import {CircleManagementDto} from "@/dto/CircleManagementDto";
import {ClientPage} from "@/entity/ClientPage";
import {CircleManagement} from "@/entity/CircleManagement";

@Component({
  components: {TieZiView, KeShangMain},
})

export default class KeShangSelect1 extends Vue {
  private customers: Customer[] = [];
  private collectCompanys: CollectCompany[] = []
  collectCompany = new CollectCompany()
  customer = new Customer();
  // user = new User();
  isAdminOpen = false;
  cs = getModule(CustomerStore);
  ls = getModule(AuthStore);
  // cm = getModule(CollectCompanyStore);
  su = SecurityUtils;
  rightDrawerOpen = true;
  drawer = false;
  tab = 'group_add';
  items = ([{}, {}, {}, {}, {}, {}, {}, {}, {}])

  customerA = new Customer()

  private qTrees: MerchantCircle[] = [];
  SaveQTree = new MerchantCircle();
  chooseTheCompanyLogo = false
  circleManagementList: CircleManagement[] =[]

  async getAll() {
    // this.qTrees = await QTreeDto.finAllQTree()
    // const a=await QTreeDto.accurateSelectQTree(this.qTrees);
    this.qTrees = await MerchantCircleDto.accurateSelectQTree();
    // console.log(a)
    // this.accurateQTree = a.data
    // console.log(a.data[0])
    // console.log(this.qTrees)
  }
  save() {
    this.SaveQTree.userId = this.ls.loginUser.username
    this.SaveQTree.userName = this.ls.loginUser.name
    this.SaveQTree.userCompany = this.collectCompany.companyName
    MerchantCircleDto.saveNewComments(this.SaveQTree)
    // this.faTeiZiDialog = false;
    this.getAll()
    location.reload();
  }

  refresh() {
    setTimeout(() => {
      // this.$router.push({name:'refresh'})
      location.reload();
      // this.$route
      // this.$router.push({name: 'keShangSelect1'})
      // this.handleClick()
     this.findAllCompanyName()
    }, 1000)
  }


  keShangSelect() {
    this.$router.push({name: 'KeShangSelect'});
  }

  keShangSelect1() {
    this.$router.push({name: 'keShangSelect1'}).catch(err => err);
  }

  keShangSelect2() {
    this.$router.push({name: 'keShangSelect2'});
  }


  // async save(d: Customer) {
  //   try {
  //     await CustomerDto.save(d);
  //     this.$q.notify('保存成功!');
  //   } catch (e) {
  //     this.$q.notify({message: '错误:' + e, color: 'red'});
  //   }
  // }

  public get columns() {
    let columns = Customer.getColumns();
    columns.push({
      label: ' ',
      name: 'edit',
      field: '',
    });
    columns = columns.filter(value => !['creatorId', 'isReviewPass'].some(s => value.name === s));
    return columns;
  }

///
  async getId(id = this.id) {
    this.customer = await CustomerDto.findById(Number(id));
  }

  goToZiZhangHaoGuanLi() {
    this.$router.push({name: 'ZiZhangHao'});
  }

  get id() {
    return this.$route.params.id as string;
  }

  get customerName() {

    return this.collectCompany.companyName;
  }

  // saveCompany() {
  //   localStorage.setItem("name", this.cs.currentCustomer.name)
  // }

  // companyName() {
  //   const item: string | null = localStorage.getItem("name");
  //   if (item == null) {
  //     return "home"
  //   }
  //   return item;
  // }


  // currentCollectName (){
  //
  // }

  get userName() {
    return this.ls.loginUser.username
  }


  toggleRightDrawer() {
    this.rightDrawerOpen = !this.rightDrawerOpen;
  }


  async findAll() {
    const id = this.su.getLoginUser().id as number;
    const customer = new Customer();
    customer.creatorId = id;
    this.customers = await CustomerDto.findAll(customer);
    for (const value of this.su.getLoginUser().authorities) {
      if (value.authority.startsWith('ROLE_CUSTOMER_')) {
        const id = Number(value.authority.replace('ROLE_CUSTOMER_', '').replace('_ADMIN', ''));
        if (!this.customers.some(c => c.id === id)) {
          const customer = await CustomerDto.findById(id);
          if (typeof customer !== 'undefined') {
            this.customers.push(customer);
          }
        }
      }
    }
  }

  async findAllCompanyName() {
    try {
      const id = this.su.getLoginUser().id as number;
      this.collectCompany = await CollectCompanyDto.findById(id)
      this.chooseTheCompanyLogo = true
    }catch (e) {
      // this.$q.notify({message: '您没有选择公司，请先选择公司方可查看'});
      this.chooseTheCompanyLogo = false
    }



  }

  // suc() {
  //   AuthTokenDto.logout();
  //   this.$router.push({name: 'login'});
  // }

  private module: CustomerStore = getModule(CustomerStore);

  handleClick(c: Customer) {
    this.module.setCurrentCustomer(c);
    this.collectCompany = new CollectCompany()
    this.collectCompany.userName = this.ls.loginUser.username
    this.collectCompany.userId = this.ls.loginUser.id
    this.collectCompany.companyName = c.name
    this.collectCompany.customerAppId = c.id
    this.collectCompany.isReviewPass = c.isReviewPass
    CollectCompanyDto.save(this.collectCompany)
    this.rightDrawerOpen = !this.rightDrawerOpen;
  }

  async initializationCircleManagement() {
    const clientPage = new ClientPage()
    clientPage.page = '1'
    clientPage.size = '20'
    const a = await CircleManagementDto.queryCircleManagementPageList(clientPage)
    this.circleManagementList = []
    for (let i = 0; i < a.length; i++) {
      this.circleManagementList.push(a[i])
    }
  }

  private async mounted() {
    await this.initializationCircleManagement()

    // this.findAll().then(value => {
    //   this.tab = this.companyName();
    //   const find = this.customers.find(c => c.name===this.tab);
    //   if (find !== undefined) {
    //     this.handleClick(find);
    //   }
    //   this.tab='group_add';
    // });
    // return;
    this.findAll()
    // console.log( this.findAllCompanyName())
    // const id = this.su.getLoginUser().id as number;
    // this.collectCompany = await CollectCompanyDto.findById(id)
    // const  idA = this.collectCompany.customerAppId as  number
    // this.handleClick(await CustomerDto.findById(idA))
    this.findAllCompanyName();
    this.getAll()

  }


}
